export default "__VITE_ASSET__mzztk9hT__"